import React from 'react';
import styles from './privateApp.module.scss';
import promoImage from 'assets/images/private_app/hero.png';
import clsx from 'clsx';
import useWindowSize from 'utils/useWindowSize';
import { useSelector } from 'react-redux';
import { getActiveSalon } from 'Containers/Auth/store/selectors';
import PrimaryButton from 'Containers/Common/Buttons/PrimaryButton';
import { sendMessageToApp } from 'utils/exsternalCall';

const PrivateAppPage = () => {
  const { isMobile } = useWindowSize();
  const activeSalon = useSelector(getActiveSalon());

  const handleWhatsappClick = () => {
    const salonName = activeSalon?.name || '';
    const messageText = `Ciao, sono interessato all'offerta per il mio salone ${salonName}`;
    const url = `https://wa.me/393533357748?text=${encodeURIComponent(messageText)}`;

    if (!localStorage.getItem('fromApp')) window?.open(url, '_blank');
    else sendMessageToApp('app:whatsapp', { number: '393533357748', text: messageText });
  };

  return (
    <section className={styles.hero}>
      <div className={clsx(styles.container, { [styles.container_mobile]: isMobile })}>
        <div className={styles.text_section}>
          <span className={styles.badge}>OFFERTA LANCIO</span>
          <h1 className={styles.title}>Cerchi un&apos; App personalizzata?</h1>
          <p className={styles.description}>
            Puoi avere la tua App esclusiva aggiungendo solo 14,90€ + IVA al tuo piano
            d&apos;abbonamento.
          </p>
          <p className={styles.note}>
            *si applicano termini e condizioni di ZetaBarber
          </p>
          <div className={styles.actions_section}>
            <PrimaryButton
              text="RICHIEDI ORA"
              onClick={handleWhatsappClick}
              width={isMobile ? '100%' : 'auto'}
              height={isMobile ? '50px' : '44px'}
            />
          </div>
        </div>
        <div className={styles.image_section}>
          <img src={promoImage} alt="App privata ZetaBarber" className={styles.image} />
        </div>
      </div>
      <div className={styles.actions_section_mobile}>
        <PrimaryButton
          text="RICHIEDI ORA"
          onClick={handleWhatsappClick}
          width={isMobile ? '100%' : 'auto'}
          height={isMobile ? '50px' : '44px'}
        />
      </div>
    </section>
  );
};

export default PrivateAppPage;

